import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import { appApi } from '../../../utils/endpoints/appApi';
import { handleApiRejection } from '../../../utils/lib';

import http from '../../../services/http';

export const loginAction = createAction('auth/login');

export const loginUser = createAsyncThunk(loginAction.type, async (authData, thunkApi) => {
    try {
        const response = await http.post(appApi.login, authData);
        return response.data;
    } catch (error) {
        return thunkApi.rejectWithValue(handleApiRejection(error));
    }
});



